import {
  CheckCircleIcon,
  ClockIcon,
  XCircleIcon,
} from "@heroicons/react/20/solid";
import { cn } from "helpers/classNames";
import {
  WasteStationNotification,
  WasteStationNotificationStatus,
} from "types/wasteStationNotification.type";

type Props = {
  notification?: WasteStationNotification;
  className?: string;
};

export const WasteStationNotificationStatusBadge = ({
  notification,
  className,
}: Props) => {
  if (!notification) return null;

  const { status } = notification;

  const baseClass =
    "inline-flex w-fit items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium";

  if (status === WasteStationNotificationStatus.Approved) {
    return (
      <span className={cn(baseClass, "bg-cyan-100 text-cyan-800", className)}>
        <CheckCircleIcon className="h-4 w-4" />
        Accepterad
      </span>
    );
  }

  if (status === WasteStationNotificationStatus.Rejected) {
    return (
      <span className={cn(baseClass, "bg-rose-100 text-rose-700", className)}>
        <XCircleIcon className="h-4 w-4" />
        Nekad
      </span>
    );
  }

  if (status === WasteStationNotificationStatus.Pending) {
    return (
      <span className={cn(baseClass, "bg-amber-100 text-amber-700", className)}>
        <ClockIcon className="h-4 w-4" />
        Väntar
      </span>
    );
  }

  return null;
};
